import React, { memo, useState, useEffect } from 'react';
import { Flex } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';
import Config from 'config/Config';
import cx from 'classnames';
// import Stores from 'config/Stores';
import styles from './index.modules.less';

const LinkStoreInfoCell = memo((props) => {
  const {
    containerStyle, // Object 容器样式
    data = {} // dataObj // Object 数据源
  } = props;
  const {
    avatar,
    realName,
    // certificationStatus, // 0 未认证 1 已认证
    cardCode,
    cardType, // cardType 卡类型（-1优惠顾客， 0普，1银，2金，3钻, 4钻1, 5钻2, 6钻3}
    isVip, // 是否vip（0否，1是）
    memberStatus, // 会员状态 0有效，1未激活，2未续约，3注销，4冻结 5休眠期
    cardLevelNameType, // 0 卡类型 1 卡类型名称(cardTypeName)
    firstClassTag, // 头等舱
    cardTypeName,
    shopCode,
    memberRetail,
    storeAddress
  } = data || {};

  /**
   * 是否为固定的卡号需隐藏功能
   */
  const isHiddenCardCode = () => {
    let hiddenCardCodeList = ['68989835', 'ZS400511', 'ZS400336', 'YY021996'];
    return hiddenCardCodeList.includes(cardCode);
  };

  const renderCardType = () => {
    let title = '';
    let titleColor = '#000000';
    let leftGradient = '';
    let rightGradient = '';
    switch (`${cardType}`) {
      case '-1':
        if (memberRetail) {
          title = '会员';
          titleColor = '#ffffff';
          leftGradient = '#D6BB93';
          rightGradient = '#C29B60';
        } else {
          title = '优惠顾客';
          leftGradient = '#F2E2F7';
          rightGradient = '#CDBCE3';
        }
        break;
      case '0':
        title = '普卡';
        leftGradient = '#FFF0EA';
        rightGradient = '#F9D6C8';
        break;
      case '1':
        title = '银卡';
        leftGradient = '#ECF2FA';
        rightGradient = '#E1EDF3';
        break;
      case '2':
        title = '金卡';
        titleColor = '#000000';
        leftGradient = '#FFEBBA';
        rightGradient = '#FFC568';
        break;
      case '3':
        title = '钻卡';
        titleColor = '#ffffff';
        leftGradient = '#363636';
        rightGradient = '#000000';
        break;
      default:
        return '';
    }
    // cardLevelNameType === 1 && (title = cardTypeName);
    if (cardTypeName) {
      title = cardTypeName;
    }
    return (
      <div
        className={styles.cardContent}
        style={{
          color: titleColor,
          background: `linear-gradient(to right, ${leftGradient}, ${rightGradient})`
        }}>
        {title}
      </div>
    );
  };

  const renderAuthentication = () => {
    return <div className={styles.notCertified}>未认证</div>;
    // return certificationStatus === 1 ? (
    //   <div className={styles.certified}>已认证</div>
    // ) : (
    //   <div className={styles.notCertified}>未认证</div>
    // );
  };

  const renderStoreTagView = () => {
    return (
      <div className={styles.tagGroup}>
        {isVip == 1 && !isHiddenCardCode() && (
          <img className={styles.vipImg} src={`${CDN_BASE}assets/imgs/shop/member/VIP1.png`} />
        )}
        {!isHiddenCardCode() && renderCardType()}
        {renderAuthentication()}
        {!!firstClassTag && (
          <Flex className={cx(styles.userInfoContentClass)} justify="center">
            <span>{'头等舱'}</span>
            <img src="https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/life/firstClass.png" />
          </Flex>
        )}
        {
          <div
            className={cx(styles.cardStatus, {
              [styles.statusEffective]: memberStatus == 0,
              [styles.statusRed]: memberStatus > 0 && memberStatus < 3,
              [styles.statusGrey]: memberStatus >= 3
            })}>
            {['有效', '未激活', '未续约', '注销', '冻结', '休眠期'][memberStatus]}
          </div>
        }
      </div>
    );
  };

  const renderHeadGroup = () => {
    // let levelImg = '';
    let vImg = '';
    switch (`${cardType}`) {
      case '-1':
        // levelImg = memberRetail // 开启去门槛则将优惠顾客图标换为会员
        //   ? `${CDN_BASE}assets/imgs/shop/member/discount.png` // 会员
        //   : `${CDN_BASE}assets/imgs/shop/member/discount1.png`; // 优惠顾客
        break;
      case '0':
        // levelImg = `${CDN_BASE}assets/imgs/shop/member/normal.png`;
        vImg = `${CDN_BASE}assets/imgs/promote/V1.png`;
        break;
      case '1':
        // levelImg = `${CDN_BASE}assets/imgs/shop/member/silver.png`;
        vImg = `${CDN_BASE}assets/imgs/promote/V2.png`;
        break;
      case '2':
        // levelImg = `${CDN_BASE}assets/imgs/shop/member/gold.png`;
        vImg = `${CDN_BASE}assets/imgs/promote/V3.png`;
        break;
      case '3':
        // levelImg = `${CDN_BASE}assets/imgs/shop/member/diamond.png`;
        vImg = `${CDN_BASE}assets/imgs/promote/V4.png`;
        break;
    }
    if (shopCode) {
      vImg = `${CDN_BASE}assets/imgs/promote/V5.png`;
    }
    return (
      <div className={styles.imgBox}>
        <ImgWrap src={avatar || Config.uploadImgdefault} mode="full" w="96px" h="96px" r="48px" />
        {vImg && <img className={styles.vipImg2} src={vImg} />}
      </div>
    );
  };

  return (
    <Flex
      direction="row"
      align="center"
      style={{
        ...containerStyle
      }}
      className={styles.storeInfoContainer}
      onClick={() => {
        // window.app.routerGoTo({
        //   pathname: `/storeInfo`
        // });
      }}>
      {renderHeadGroup()}
      <div className={styles.rightGroup}>
        <div className={styles.rightTop}>
          <div className={styles.storeName}>{realName || '您'}的店铺</div>
          {/* <ImgWrap src={`${CDN_BASE}/assets/imgs/store_right_icon.png`} w="32px" h="32px" /> */}
        </div>
        {renderStoreTagView()}
        {<div className={styles.storeAddr}>店铺地址：{storeAddress || '无'}</div>}
      </div>
    </Flex>
  );
});

export default LinkStoreInfoCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/LinkStoreInfoCell/index.js